// extracted by mini-css-extract-plugin
export default {"-large":"Uw9wOFDU93BgM80loFPh","fullLogo":"aNULwe4E9OGb4xOX0DnO","logoIcon":"HxS7sHnlwZpIGK_4qesD","container":"AHeSj8tYc0reGLeXu89_","relative":"e8EiGdnQTXaoBOBQyMfY"};